import { render, staticRenderFns } from "./Audio.vue?vue&type=template&id=a441a284&"
import script from "./Audio.vue?vue&type=script&lang=js&"
export * from "./Audio.vue?vue&type=script&lang=js&"
import style0 from "./Audio.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qhotian/Project/haodf/hb-editor/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a441a284')) {
      api.createRecord('a441a284', component.options)
    } else {
      api.reload('a441a284', component.options)
    }
    module.hot.accept("./Audio.vue?vue&type=template&id=a441a284&", function () {
      api.rerender('a441a284', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/detailComp/audio/Audio.vue"
export default component.exports